import React from 'react';
import OptionButton from '../shared/OptionButton';
import { ExperienceLevel } from '../../../types/enums';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const options = [
  { label: 'Beginner', value: ExperienceLevel.BEGINNER, description: "You're new to running, focused on building fitness and being able to complete a 5km without stopping." },
  { label: 'Novice', value: ExperienceLevel.NOVICE, description: 'Can run 5-10km comfortably, looking to build distance.' },
  { label: 'Intermediate', value: ExperienceLevel.INTERMEDIATE, description: 'Regular runner, completed races, looking for structured training.' },
  { label: 'Advanced', value: ExperienceLevel.ADVANCED, description: 'Experienced competitive runner with specific performance goals.' },
];

const ExperienceLevelStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {options.map((opt) => (
        <OptionButton
          key={opt.value}
          label={opt.label}
          value={opt.value}
          description={opt.description}
          selected={answer === opt.value}
          onClick={onAnswer}
        />
      ))}
    </div>
  );
};

export default ExperienceLevelStep;
